import * as historyModule from 'history';
export const history = historyModule.createBrowserHistory();